
<div *ngIf="searchResults">
    <div class="bg-primary p-2">
        <div class="contract2020-row d-flex justify-content-between">
            <div class="col-lg-7 col-md-6 col-6 dropdown drop-right">
                <button type="button" class="btn btn-primary dropdown-toggle" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" data-display="static"> Filter: View All </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <ng-container *ngFor="let filter of searchResults.Filters">
                        <a class="dropdown-item" href="#" (click)="onFilterClick($event.target, filter.Text, filter.Value)">{{filter.Text}}</a>
                    </ng-container>
                </div>
            </div>
            <span class="sync-icon" (click)="refreshQnA()"></span>
            <div>
                <button type="button" class="btn btn-primary float-md-right ml-3" (click)="changeViewPage($event)">{{btnViewText}}</button>
            </div>
        </div>
    </div>
    <div class="accordion" id="parent-qna-all">
        <ng-container *ngFor="let qna of searchResults.Items; let first = first;">
            <ngx-spinner bdColor="rgba(0, 0, 0, 0)" size="small" color="#074f71" type="ball-elastic-dots" [fullScreen]="false"></ngx-spinner>
            <div *ngIf="!isLoading">
                <form [formGroup]="form" (submit)="publishAnswer($event,qna,textAreaQuestion.value,textAreaAnswer.value)">
                    <div [ngClass]="qna.Status=='Unpublish'?'p-3 bg-light':'p-3'" id="parentDiv-{{qna.QuestionId}}">
                        <div Class="d-flex justify-content-between pt-2">
                            <h6 class="text-primary align-items-center">
                                <span *ngIf="isSelectedEditButtonId != qna.QuestionId">{{ qna.SectionName | titlecase }} Question</span>
                                <ng-container *ngIf="isSelectedEditButtonId == qna.QuestionId">
                                    <select [formControl]="form.get('selectedSection')" class="form-control contract2020-dropdown" (change)="isQuestionTextAreaClicked = true">
                                        <option *ngFor="let section of searchResults.Sections" [value]="section.Value">{{ section.Text }}</option>
                                    </select>
                                </ng-container>
                                | {{ qna.SubmittedDateInString }}
                                | Posted by: {{ qna.IsAnonymous ? 'Anonymous&nbsp;' : qna.SubmittedBy }}
                                <span *ngIf="selectedEyeIcon == qna.QuestionId">({{qna.SubmittedBy}})&nbsp;</span>
                                <span *ngIf="qna.IsAnonymous" [ngClass]="selectedEyeIcon != qna.QuestionId ? 'eye-icon' : 'eye-slash-icon'" (click)="toggleIcons(qna.QuestionId)"></span>
                            </h6>
                            <span *ngIf="qna.Status!='Submitted'" [ngClass]="qna.IsPinned ? 'unpin-icon mr-2 ml-auto' : 'pin-icon mr-2 ml-auto'" (click)="changePinStatus(qna)"></span>
                            <a [ngClass]="qna.Status=='Submitted' || isSelectedCancelButtonId == qna.QuestionId ?'d-none':'text-primary  mr-2'" href="#"
                               id="edit-answer-{{qna.QuestionId}}"
                               data-toggle="collapse"
                               [attr.data-target]="'.qna-'+qna.QuestionId"
                               [attr.aria-expanded]="false"
                               [attr.aria-controls]="'ans-'+qna.QuestionId"
                               (click)="editAnswer($event,qna)">{{isSelectedEditButtonId == qna.QuestionId ? 'Cancel':'Edit'}}</a>
                            <a [ngClass]="isSelectedCancelButtonId != qna.QuestionId ?'d-none':'text-primary  mr-2' + ' ml-auto'" href="#"
                               id="cancel-{{qna.QuestionId}}"
                               data-toggle="collapse"
                               [attr.data-target]="'.qna-'+qna.QuestionId"
                               [attr.aria-expanded]="false"
                               [attr.aria-controls]="'qus-'+qna.QuestionId"
                               (click)="cancelButton($event,qna)">Cancel</a>
                            <a [ngClass]="qna.Status != 'Submitted' || isSelectedCancelButtonId == qna.QuestionId ? 'd-none' : 'text-primary mr-2 ml-auto'"
                               href="#"
                               id="edit-question-{{ qna.QuestionId }}"
                               data-toggle="collapse"
                               [attr.data-target]="'#qus-'+qna.QuestionId"
                               [attr.aria-expanded]="false"
                               [attr.aria-controls]="'qus-'+qna.QuestionId"
                               (click)="editQuestion($event, qna)">
                                {{isSelectedEditButtonId == qna.QuestionId ? 'Cancel':'Edit'}}
                            </a>
                            <a [ngClass]="isSelectedEditButtonId != qna.QuestionId ? 'text-danger' : 'd-none'"
                               href="#"
                               id="delete-question-{{ qna.QuestionId }}"
                               data-toggle="collapse"
                               [attr.data-target]="'#deleteQuestionModal'"
                               [attr.aria-expanded]="false"
                               [attr.aria-controls]="'qus-'+qna.QuestionId"
                               (click)="showConfirmationModal(qna.QuestionId)">
                                Delete
                            </a>
                        </div>
                        <p id="question-text-{{qna.QuestionId}}">
                            <b>Q: </b> {{qna.Question}}
                        </p>
                        <div class="collapse qna-{{qna.QuestionId}}" id="qus-{{qna.QuestionId}}" data-parent="#parent-qna-all">
                            <textarea rows="3" id="textarea-qus-{{qna.QuestionId}}"
                                      cols="5"
                                      #textAreaQuestion
                                      [ngModel]="qna.Question"
                                      (ngModelChange)="answerChanged($event,'qna-btnAnswer-'+qna.QuestionId)"
                                      autocomplete="off"
                                      class="form-control rounded py-2"
                                      maxlength="2000"
                                      formControlName="textarea-qus-{{qna.QuestionId}}"
                                      (click)="isQuestionTextAreaClicked = true"
                                      required></textarea>
                            <div class="text-secondary pt-2" *ngIf="form.get('textarea-qus-'+qna.QuestionId).invalid &&
                                    (form.get('textarea-qus-'+qna.QuestionId).dirty || form.get('textarea-qus-'+qna.QuestionId).touched)">
                                <div *ngIf="form.get('textarea-qus-'+qna.QuestionId).errors.required">{{validateAnswerMessage}}</div>
                                <div *ngIf="form.get('textarea-qus-'+qna.QuestionId).hasError('whitespace')">{{blankSpaceMessage}}</div>
                            </div>
                        </div>
                        <p id="answer-text-{{qna.QuestionId}}" [ngClass]="qna.Status=='Submitted'?'d-none':''">
                            <b>A: </b> {{qna.Answer}}
                        </p>
                        <div class="collapse qna-{{qna.QuestionId}}" id="ans-{{qna.QuestionId}}" data-parent="#parent-qna-all">
                            <textarea rows="3" id="textarea-ans-{{qna.QuestionId}}"
                                      cols="5"
                                      #textAreaAnswer
                                      [ngModel]="qna.Answer"
                                      (ngModelChange)="answerChanged($event,'qna-btnAnswer-'+qna.QuestionId)"
                                      autocomplete="off"
                                      class="form-control rounded py-2"
                                      maxlength="2000"
                                      formControlName="textarea-ans-{{qna.QuestionId}}"
                                      (click)="isAnswerTextAreaClicked = true"
                                      required></textarea>
                            <div class="text-secondary pt-2" *ngIf="form.get('textarea-ans-'+qna.QuestionId).invalid &&
                                    (form.get('textarea-ans-'+qna.QuestionId).dirty || form.get('textarea-ans-'+qna.QuestionId).touched)">
                                <div *ngIf="form.get('textarea-ans-'+qna.QuestionId).errors.required">{{validateAnswerMessage}}</div>
                                <div *ngIf="form.get('textarea-ans-'+qna.QuestionId).hasError('whitespace')">{{blankSpaceMessage}}</div>
                            </div>
                            <span [ngClass]="qna.Status=='Submitted'?'d-none':'text-primary'" id="answerdby-{{qna.QuestionId}}">Answered by <h6 class="text-primary d-inline">{{qna.AnsweredByUserId}}</h6> | {{qna.AnsweredDateInString}}</span>

                        </div>
                        <!--while formatting html make sure to trim the space in button text-->
                        <button type="submit"
                                id="qna-btnAnswer-{{qna.QuestionId}}"
                                [ngClass]="qna.Status=='Unpublish'? 'd-none':'btn btn-primary .btn-outline-transparent .shadow-none rounded-pill my-3 '"
                                data-toggle="collapse"
                                [attr.data-target]="'#ans-'+qna.QuestionId"
                                [attr.aria-expanded]="false"
                                [attr.aria-controls]="'ans-'+qna.QuestionId">
                            {{qna.Status=='Submitted'?'Answer Question':'Unpublish Question and Answer'}}
                        </button>
                        <button type="button"
                                *ngIf="qna.Status != 'Submitted' && isSelectedEditButtonId == qna.QuestionId"
                                id="qna-btnUpdateQue-{{qna.QuestionId}}"
                                [ngClass]="qna.Status !='Unpublish'? 'd-none':'btn btn-primary .btn-outline-transparent .shadow-none rounded-pill my-3 '"
                                data-toggle="collapse"
                                [attr.data-target]="'#qus-'+qna.QuestionId"
                                [attr.aria-expanded]="false"
                                [attr.aria-controls]="'qus-'+qna.QuestionId"
                                [disabled]="!(isQuestionTextAreaClicked || isAnswerTextAreaClicked)"
                                (click)="editQuesion(qna,textAreaQuestion.value)">
                            Update
                        </button>
                    </div>
                    <hr class="bg-dark m-0" />
                </form>
            </div>
        </ng-container>
    </div>

    <h6 class="text-danger text-center mt-4" *ngIf="searchResults && searchResults.TotalMatching>0" [innerHTML]="searchResults.ResultFoundMessage"></h6>
    <h6 class="text-danger text-center mt-4" *ngIf="searchResults && searchResults.TotalMatching==0" [innerHTML]="searchResults.NoResultMessage"></h6>
    <!-- pagination -->
    <div *ngIf="searchResults && searchResults.Items?.length>0 && searchResults.TotalMatching > pageSize && !isLoading" class="row justify-content-center">
        <!--<div class="col-12 col-md-5 text-left">
            <span>Showing {{endIndex}} of {{ searchResults.TotalMatching }} results</span>
        </div>-->
        <div *ngIf="!isLoading" class="my-auto">
            <ngb-pagination [collectionSize]="searchResults.TotalMatching" [(page)]="page" [pageSize]="pageSize" [maxSize]="3" [rotate]="true" [boundaryLinks]="false" (pageChange)="onChangePage($event)" aria-label="Default pagination">
            </ngb-pagination>
        </div>
    </div>

    <div *ngIf="searchResults && searchResults.Items?.length>0 && !isLoading" class="swapa-top-tocshortcut text-right text-nonselectable">
        <a class="anchor-scroll btn btn-sm btn-primary ml-auto p-1 mb-2" href="#topofbody"> ↑ Back To Top </a>
    </div>
    <div class="modal fade"
         tabindex="-1"
         role="dialog"
         id="messageModel"
         [ngStyle]="{'display':displayStyleMessageModel,'background-color':'#00000052'}">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button"
                            class="close swapa-close"
                            data-dismiss="modal"
                            aria-label="Close"
                            (click)="closePopup()"></button>
                </div>
                <div class="modal-body">
                    <p [ngClass]="isPostedAnswer || isEditedQuestion || isEditedSection ?'text-success text-center':'text-danger text-center'">{{isPostedAnswer ? postAnswerMessage : postEditQuestionMessage}}</p>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"
                            (click)="closePopup()">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade"
         tabindex="-1"
         role="dialog"
         id="confirmationModal"
         [ngStyle]="{'display':displayStyleConfirmationModal,'background-color':'#00000052'}">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">Delete Question</h5>
                    <button type="button"
                            class="close swapa-close text-white"
                            data-dismiss="modal"
                            aria-label="Close"
                            (click)="closePopup()"></button>
                </div>
                <div class="modal-body">
                    <p>Are you sure you want to delete this question?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="closePopup()">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="deleteConfirmed()">Delete</button>
                </div>
            </div>
        </div>
    </div>
</div>